/**
 * Global constants for Yalana system entities and roles.
 */

/**
 * The 'default' customer ID (UUID v5 derived from 'root-customer').
 */
export const SYSTEM_CUSTOMER_ID = "eabde437-33f8-5ec8-af8a-1cf16bcaa4ce";

/**
 * Slug for the default system customer.
 */
export const DEFAULT_CUSTOMER_SLUG = "root-customer";

/**
 * Role with global cross-customer access.
 */
export const SUPER_ADMIN_ROLE = "root";

/**
 * BEL-494 / ADR-035 §6: the single customer-plane admin role every new customer
 * is seeded with — write on every customer-plane module, no platform-plane access.
 * Replaces the old empty "registered"/"admin" role shells createCustomer used to create.
 */
export const BELORA_ADMIN_ROLE = "belora-admin";

/**
 * Well-known deterministic UUIDs (UUID v5, DNS namespace).
 * These are computed once and stored as constants to avoid DB round-trips.
 *
 * Derivation: stringToUuid(name) using DNS namespace 6ba7b810-9dad-11d1-80b4-00c04fd430c8
 *   "tenant-root" → SYSTEM_CUSTOMER_ID  (historical; UUID frozen, slug renamed to "customer-root" in migration 0087)
 *   "et-user"     → ET_USER_ID
 *   "et-role"     → ET_ROLE_ID
 */
export const WELL_KNOWN_IDS = {
  // Tenants
  SYSTEM_CUSTOMER_ID: "eabde437-33f8-5ec8-af8a-1cf16bcaa4ce", // stringToUuid("tenant-root") — frozen UUID, do not regenerate
  // Entity types
  ET_USER_ID: "53904a0c-6066-554b-b7a8-efefd62fbe8d", // stringToUuid("et-user")
  ET_ROLE_ID: "1cc6e019-23c8-5d97-8e1a-d00f3dc353e7", // stringToUuid("et-role")
  ET_SYSTEM_ID: "a306ba4b-dca0-501d-8929-d148b86240cc", // stringToUuid("et-system")
  // Role entities (in root customer)
  ENT_ROLE_ROOT_ID: "524dcdaf-7244-5fec-bdab-4f08b8f7e662", // stringToUuid("ent-role-root")
  ENT_ROLE_REGISTERED_ID: "9a85a777-6cae-5c83-bb3b-f5af5a959d2a", // stringToUuid("ent-role-registered")
  // Root user
  ROOT_USER_ID: "c7ff8f15-3e68-59bf-bb15-0c7ef762955b", // stringToUuid("user:i@d13z.dev")
} as const;
